// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ZdZv","infoBtn":"quickbooks_infoBtn__1Yraz","formBox":"quickbooks_formBox__2G40U","formFooter":"quickbooks_formFooter__3PXGp"};